module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row col-md-12"
  }, [_vm._v("\n  from\n    "), _c('datepicker', {
    staticClass: "col-md-5",
    attrs: {
      "clear-button": true,
      "clear-button-icon": "fa fa-times",
      "calendar-button": true,
      "calendar-button-icon": "fa fa-calendar",
      "inputClass": "dateinput",
      "bootstrapStyling": true
    },
    on: {
      "input": _vm.onInput
    },
    model: {
      value: (_vm.start),
      callback: function($$v) {
        _vm.start = $$v
      },
      expression: "start"
    }
  }), _vm._v("\n  to\n    "), _c('datepicker', {
    staticClass: "col-md-5",
    attrs: {
      "clear-button": true,
      "clear-button-icon": "fa fa-times",
      "calendar-button": true,
      "calendar-button-icon": "fa fa-calendar",
      "inputClass": "dateinput",
      "bootstrapStyling": true
    },
    on: {
      "input": _vm.onInput
    },
    model: {
      value: (_vm.end),
      callback: function($$v) {
        _vm.end = $$v
      },
      expression: "end"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30c361c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DateRange.vue
// module id = 698
// module chunks = 1